<template>
    <div id="app-wrapper" :data-user-email="userEmail">
        <Offline />
        <component :is="layout">
            <router-view />
        </component>
        <Toast group="messages">
            <template #message="slotProps">
                <div class="p-toast-message-text">
                    <SCLabel class="p-toast-summary" bold :text="slotProps.message.summary" />
                    <SCParagraph class="p-toast-detail" v-html="slotProps.message.detail"></SCParagraph>
                </div>
            </template>
        </Toast>
        <SitewideMessage />
        <SCConfirm></SCConfirm>
        <ClusterUpdatesAvailableModal />
        <ClusterUpdatesStatusModal />
    </div>
</template>
<script>
import SitewideMessage from '@/components/app/SitewideMessage.vue';
import ClusterUpdatesAvailableModal from '@/components/cluster/UpdatesAvailableModal.vue';
import Offline from '@/components/shared/offline/Offline.vue';
import ClusterUpdatesStatusModal from '@/components/cluster/UpdateStatusModal.vue';
import { SCConfirm, SCLabel, SCParagraph } from '@scale-computing/scale-design-framework';


export default {
    components: {
      SitewideMessage,
      ClusterUpdatesAvailableModal,
      ClusterUpdatesStatusModal,
      SCConfirm,
      SCLabel,
      SCParagraph,
      Offline
  },
  computed: {
      layout() {
        return 'layout-' + (this.$route.meta.layout || 'empty');
      },
      userEmail() {
            return this.$store.user.profile.email || null;
        },
  },
  methods: {},
};
</script>

<style lang="scss">
.p-toast.p-toast-top-right {
    z-index: 10001; // Ensure it's above everything including modals
}

.p-toast-message {
    border-radius: 8px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
    color: #131314 !important; // Dark text for better contrast

    &.p-toast-message-info,
    &.p-toast-message-success,
    &.p-toast-message-warn,
    &.p-toast-message-error {
        // No background override - keep original theme colors
        
        .p-toast-message-icon,
        .p-toast-icon-close {
            color: #131314 !important; // Dark icons/close button
        }
    }

    .p-toast-message-content {
        padding: 1rem !important;
        align-items: flex-start !important;
    }

    .p-toast-message-text {
        margin: 0 0 0 1rem !important;
        flex: 1;
        
        // Target everything inside to ensure dark color
        * {
            color: #131314 !important;
        }
    }
}

.p-toast-summary {
    display: block;
    margin-bottom: 0.25rem;
}

.p-toast-detail {
    margin: 0 !important;
    
    // Ensure SCParagraph inside toast looks correct
    .sc-paragraph {
        margin: 0 !important;
        font-size: 0.9rem !important;
        line-height: 1.4 !important;
    }

    a, a * {
        color: #2371b9 !important; // Standard SC blue for links and anything inside them
        text-decoration: underline;
        font-weight: 600;

        &:hover {
            opacity: 0.8;
            color: #1a5691 !important;
        }
    }
}
</style>
